import React from 'react';
import { Box } from '@mui/material';
import PitchingStatsTable from '../components/PitchingStatsTable';
import { API_ENDPOINTS } from '../config/api';

const CareerPitchingStatsPage = () => {
  return (
    <Box sx={{ p: 3 }}>
      <PitchingStatsTable apiUrl={API_ENDPOINTS.PLAYER_PITCHING_STATS} careerStats={true} />
    </Box>
  );
};

export default CareerPitchingStatsPage; 